import { render, staticRenderFns } from "./ImgWrapper.vue?vue&type=template&id=dd20d8c0&"
import script from "./ImgWrapper.vue?vue&type=script&lang=js&"
export * from "./ImgWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports